import { Outlet } from 'react-router-dom';

interface ILocationDescriptor {
  pathname: string;
  search: string;
  hash: string;
  key?: string;
  query?: Record<string, string>;
  state: {
    language: string;
    salesAdmission: string;
    fundsList: {
      liveFilterInfo: {
        fundsname: [string];
        isin: [string];
      };
    };
  };
}

interface FundsServicePropsType {
  children?: React.ReactNode;
}

// Functional component that serves as the root layout.
// Renders <Outlet /> for nested route content in react-router v6.
const FundsService: React.FC<FundsServicePropsType> = ({ children }) => {
  return (
    <div>
      {children || <Outlet />}
      <div className="Footer" />
    </div>
  );
};

export { FundsService as default, type ILocationDescriptor };
